export enum JobFilterRadius {
  RADIUS30 = '30',
  RADIUS50 = '50',
  RADIUS100 = '100',
  RADIUS200 = '200',
}
